import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoweroffOutlinedSvg from "@ant-design/icons-svg/es/asn/PoweroffOutlined";
import AntdIcon from '../components/AntdIcon';
var PoweroffOutlined = function PoweroffOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PoweroffOutlinedSvg
  }));
};
PoweroffOutlined.displayName = 'PoweroffOutlined';
export default /*#__PURE__*/React.forwardRef(PoweroffOutlined);